import { Static } from 'core-components/types'
import { Crud } from 'core/types/Crud'

import { quarters } from '../config'
import { TQuarter } from '../models'

import { getOpportunitiesYears } from './getOpportunitiesYears'

const formData = (years: number[], quarters: TQuarter[]) => {
  return years.reduce((res, year) => {
    const yearAndQuarters = quarters.reduce((acc, quarter) => {
      return [...acc, `${year} ${quarter}`]
    }, [] as string[])

    return [...res, ...yearAndQuarters]
  }, [] as string[])
}

export const getYearAndQuarterCrud = (currentYear: number) => {
  const years = getOpportunitiesYears(currentYear)
  const data = formData(years, quarters)
  return new Crud({
    fetcher: new Static(data.map((el) => ({ key: el, label: el }))),
    keyField: 'key',
  })
}
